import Component from '@glimmer/component'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import type { BufferedChangeset } from 'ember-changeset/types'
import type ProgressHandlerService from 'teacher-ui-client/services/progress-handler'
import type { ProgressionRecord } from 'teacher-ui-client/progress-handler/utils'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { EditProgressSelect } from 'teacher-ui-client/components/form/edit-progress/select'

interface Args {
  progressChangeset: BufferedChangeset
  /**
   * An array of progression items from student-progress service for a student
   */
  studentProgression?: ProgressionRecord[]
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
  Blocks: {
    default: []
  }
}

export class EditProgressMathseeds extends Component<Signature> {
  themeKey = ThemeKeys.darkBlue

  @service progressHandler!: ProgressHandlerService

  <template>
    <div class="grid grid-cols-[33%_66%] items-baseline justify-between gap-y-3" ...attributes>
      <label for={{this.progressHandler.mathseedsLessonsHandler.progressType}}>
        {{t "manage.manageProgress.editProgress.maths.lessons"}}
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsLessonsHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      <label for={{this.progressHandler.mathseedsMentalMinuteAddSubHandler.progressType}}>
        {{t "manage.manageProgress.editProgress.maths.mentalMinute"}}
        <div class="leading-none font-normal">{{t "manage.manageProgress.editProgress.maths.mentalMinuteAddSub"}}</div>
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsMentalMinuteAddSubHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
      <label for={{this.progressHandler.mathseedsMentalMinuteMulDivHandler.progressType}}>
        {{t "manage.manageProgress.editProgress.maths.mentalMinute"}}
        <div class="leading-none font-normal">{{t "manage.manageProgress.editProgress.maths.mentalMinuteMulDiv"}}</div>
      </label>
      <EditProgressSelect
        @progressHandler={{this.progressHandler.mathseedsMentalMinuteMulDivHandler}}
        @progressChangeset={{@progressChangeset}}
        @studentProgression={{@studentProgression}}
        @themeKey={{this.themeKey}}
      />
    </div>
  </template>
}

export default EditProgressMathseeds
